
export const DAYS = [
  { id: 'monday', name: '월요일' },
  { id: 'tuesday', name: '화요일' },
  { id: 'wednesday', name: '수요일' },
  { id: 'thursday', name: '목요일' },
  { id: 'friday', name: '금요일' },
  { id: 'saturday', name: '토요일' },
  { id: 'sunday', name: '일요일' }
];

export const TYPE_STYLES = {
  daily: { 
    border: 'border-blue-300',
    bg: 'bg-blue-50',
    labelBg: 'bg-blue-100',
    labelText: 'text-blue-700'
  },
  permanent: { 
    border: 'border-green-300',
    bg: 'bg-green-50',
    labelBg: 'bg-green-100',
    labelText: 'text-green-700'
  },
  rare: {
    border: 'border-purple-300',
    bg: 'bg-purple-50',
    labelBg: 'bg-purple-100',
    labelText: 'text-purple-700'
  },
  period: {
    border: 'border-cyan-300',
    bg: 'bg-cyan-50',
    labelBg: 'bg-cyan-100',
    labelText: 'text-cyan-700'
  }
};
